import React, { useState, useEffect } from 'react';
import { 
  Row, 
  Col, 
  Card, 
  Statistic, 
  Table,
  Tag,
  message
} from 'antd';
import { 
  UserOutlined,
  DollarOutlined,
  GiftOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { agencyDashboardService, AgencyDashboardStats } from '../../services/agencyDashboardService';
import MonthlyStatsChart from '../../components/dashboard/MonthlyStatsChart';
import TableFilter, { FilterConfig } from '../../components/TableFilter/TableFilter';
import { useOptimizedPageSearch } from '../../hooks/useOptimizedPageSearch';
import moment from 'moment';
import { cartService } from 'services/cartService';
import PaymentsTable from 'components/PaymentsTable/PaymentsTableDashboard(agency)';

interface BalanceInfo {
  sufficient: boolean;
  currentBalance: number;
  requiredAmount: number;
}

const AgencyDashboard: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<AgencyDashboardStats>({
    totalSubscribers: 0,
    //solde: 0,
    monthlyRevenue: 0,
    activeVouchers: 0,
    totalTransactions: 0,
    recentTransactions: [],
    monthlyStats: []
  });

  const [balanceInfo, setBalanceInfo] = useState<BalanceInfo>(null);

  {/*const { 
    filteredData: filteredTransactions, 
    handleFilterChange, 
    handleClearFilters 
  } = useOptimizedPageSearch<any>({
    data: stats.recentTransactions || [],
    searchFields: ['id', 'type', 'amount', 'status']
  });*/}

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await agencyDashboardService.getStats();
        setStats(response.data);
      } catch (error) {
        message.error(t('agency.messages.dashboardLoadError'));
      } finally {
        setLoading(false);
      }
      try {
        const balanceCheck = await cartService.checkBalance();
        setBalanceInfo(balanceCheck);
      } catch (error) {
        console.error(t('agency.messages.balanceCheckError'), error);
        setBalanceInfo({
          sufficient: false,
          currentBalance: 0,
          requiredAmount: 0
        });
      }
    };
    
    fetchData();
  }, [t]);

  // Configuration des filtres pour les transactions récentes
  {/*const filterConfig: FilterConfig[] = [
    {
      key: 'type',
      type: 'select',
      label: t('common.type'),
      options: [
        { label: 'PAYMENT', value: 'PAYMENT' },
        { label: 'REFUND', value: 'REFUND' },
        { label: 'COMMISSION', value: 'COMMISSION' }
      ]
    },
    {
      key: 'amount',
      type: 'numberRange',
      label: t('common.amount')
    },
    {
      key: 'date',
      type: 'dateRange',
      label: t('common.date')
    }
  ];*/}

  {/*const transactionColumns = [
    {
      title: t('agency.dashboard.transactionId'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('agency.dashboard.transactionType'),
      dataIndex: 'type',
      key: 'type',
      render: (type) => (
        <Tag color={type === 'PAYMENT' ? 'green' : 'volcano'}>
          {type}
        </Tag>
      ),
    },
    {
      title: t('agency.dashboard.transactionAmount'),
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => `${amount} €`,
    },
    {
      title: t('agency.dashboard.transactionDate'),
      dataIndex: 'date',
      key: 'date',
      render: (date) => moment(date).format('DD/MM/YYYY'),
    },
  ];*/}

  return (
    <div className="agency-dashboard">
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card>
            <h2>{t('agency.dashboard.title')}</h2>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title={t('agency.dashboard.mySubscribers')}
              value={stats.totalSubscribers}
              prefix={<UserOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title={t('agency.dashboard.myVouchers')}
              value={stats.activeVouchers}
              prefix={<GiftOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title={t('agency.dashboard.myBalance')}
              value={balanceInfo?.currentBalance?.toFixed(2) ?? '-'}
              suffix="€"
              prefix={<DollarOutlined />}
            />
          </Card>
        </Col>
      </Row>

      {/* Section des transactions */}
      {/*<Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Card title={t('agency.dashboard.recentTransactions')}>
            <TableFilter
              filters={filterConfig}
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
            />
            <Table
              columns={transactionColumns}
              dataSource={filteredTransactions}
              loading={loading}
              rowKey="id"
              pagination={{ pageSize: 5 }}
            />
          </Card>
        </Col>
        <Col span={24}>
          <MonthlyStatsChart data={stats.monthlyStats || []} loading={loading} />
        </Col>
      </Row>*/}

      {/* Transactions récentes */}
      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Card title={t('agency.dashboard.recentTransactions')}>
            <PaymentsTable
              title=""
              //showFilters={true}
              pageSize={10}
            />
          </Card>
        </Col>
      </Row>

    </div>
  );
};

export default AgencyDashboard;